import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "app-cbox-profile-finance-unpaid-orders-list",
  templateUrl: "./cbox-profile-finance-unpaid-orders-list.component.html",
  styleUrls: ["./cbox-profile-finance-unpaid-orders-list.component.scss"],
  standalone: true,
  imports: [
    CommonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CBoxProfileFinanceUnpaidOrdersListComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}